export function pgup(name, href) {
  if (href == null) return null;

  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regexS = "[\\?&]" + name + "=([^&#]*)";
  var regex = new RegExp(regexS);
  var results = regex.exec(href);
  if (results == null) return null;
  else return results[1];
}
